import { MigrationManifest, PersistedState } from 'redux-persist/es/types';

const claimMigration: MigrationManifest = {
    '0': (previousState: PersistedState) => previousState,
};

export default claimMigration;
